import { render, staticRenderFns } from "./BackupManagement.vue?vue&type=template&id=4b07ac80&scoped=true&"
import script from "./BackupManagement.vue?vue&type=script&lang=js&"
export * from "./BackupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07ac80",
  null
  
)

export default component.exports